import debugObject from 'debug';
import fileType from 'file-type/browser';
import utils from '../../../common/livr/livr-utils';
import {PHONE_NUMBER_INPUT_FIELDS} from './DNFORM-constants';

const debug = debugObject('sf:dynaform:dnform-utils');

function getRealFileExtension(file, fileExtensionFromFilename) {
	return new Promise((resolve, reject) => {
		const fileReader = new FileReader();
		fileReader.readAsArrayBuffer(file);

		fileReader.onload = function () {
			fileType.fromBuffer(fileReader.result)
				.then((response) => {
					// file-type can't detect text-based file formats, that's why we have a
					// fallback value with the file extension from filename
					const resultToResolve = response && response.ext ? response.ext : fileExtensionFromFilename;
					resolve(resultToResolve);
				})
				.catch((error) => {
					reject(error);
				});
		};

		fileReader.onerror = function (error) {
			reject(error);
		};
	});
}

export function hasFileWithFakeExtension(files) {
	debug('hasFileWithFakeExtension');
	return new Promise((resolve) => {
		const results = [];

		for (const file of Array.from(files)) {
			const fileExtensionFromFilename = utils.getFileExtensionFromFilename(file.name);
			debug('for file of files', {fileExtensionFromFilename});
			results.push(new Promise((nestedResolve) => {
				getRealFileExtension(file, fileExtensionFromFilename)
					.then((realFileExtension) => {
						const hasError = fileExtensionFromFilename !== realFileExtension;
						debug('getRealFileExtension hasError', {realFileExtension, hasError});
						nestedResolve(hasError);
					})
					.catch(() => {
						debug('getRealFileExtension catch');
						nestedResolve(true);
					});
			}));
		}

		Promise.all(results)
			.then((response) => {
				debug('Promise all', {response});
				const hasError = response.some((_response) => !!_response);
				debug('Promise all', {hasError});
				resolve(hasError);
			}).catch(() => {
				resolve(true);
			});
	});
}

export function convertArrayToObject(array) {
	const result = {};

	array.forEach((el, index) => {
		result[index + 1] = el;
	});

	return result;
}

export function isObject(value) {
	return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isPhoneNumberObject(object) {
	const keys = Object.keys(object);
	const phoneNumberFields = Object.values(PHONE_NUMBER_INPUT_FIELDS);
	return keys.length == phoneNumberFields.length && keys.every((key) => phoneNumberFields.includes(key));
}



// WEBPACK FOOTER //
// ../source/modules/DNFORM/DNFORM-utils/DNFORM-utils.js